import jQuery from "jquery"
import Rails from "@rails/ujs"

import "bootstrap"
// select2's CommonJS export is a factory that installs the plugin, so importing it is not
// enough — it has to be called with the jQuery instance it should extend.
import installSelect2 from "select2"
import "select2/dist/css/select2.css"

import "../custom/jquery.are-you-sure"
import "../custom/dirty-check"
import "../custom/jquery.sortable"
import "../custom/thumbnail-sortable"
import "../custom/manual"
import "../custom/image-picker"
import "../custom/file_input"

import "../custom/edit_frame"
import "../custom/edit_preparation"
import "../custom/edit_statistic_card"
import "../custom/edit_stories_card"
import "../custom/edit_pros_and_cons_card"
import "../custom/edit_timeline_card"
import "../custom/pros_and_cons_cards"
import "../custom/publish_to_patient_group"

// The inline <script type="module"> blocks in the views call $ and select2 directly, and
// they run after this entrypoint, so the globals have to be published here. Everything
// imported above pulls in jquery itself, so they all share this one instance.
window.jQuery = jQuery
window.$ = jQuery

installSelect2(window, jQuery)

// The npm build of @rails/ujs does not start itself the way the rails-ujs asset did.
Rails.start()

// Every text input starts out with a change event so the content-size checks in
// app/frontend/custom run against whatever was loaded from the database.
jQuery(document).ready(function() {
  jQuery(":input[type=text], textarea").each(function() {
    jQuery(this).trigger(jQuery.Event("change"))
  })
})
